import TeamTable from './TeamTable'

export default function TeamSettings() {
  return (
    <div>
      <div className="px-4 sm:px-6 lg:px-8">
        <TeamTable />
      </div>
    </div>
  )
}
